// Copyright 2020
//   __  __                       _           _     _   _            _ _   _
//  |  \/  | ___   ___  _ __  ___| |__   ___ | |_  | | | | ___  __ _| | |_| |__
//  | |\/| |/ _ \ / _ \| '_ \/ __| '_ \ / _ \| __| | |_| |/ _ \/ _` | | __| '_ \
//  | |  | | (_) | (_) | | | \__ \ | | | (_) | |_  |  _  |  __/ (_| | | |_| | | |
//  |_|  |_|\___/ \___/|_| |_|___/_| |_|\___/ \__| |_| |_|\___|\__,_|_|\__|_| |_|
//
//  All Rights Reserved.
//
// NOTICE:  All information contained herein is, and remains
// the property of Moonshot Health Incorporated and its suppliers,
// if any.  The intellectual and technical concepts contained
// herein are proprietary to Adobe Systems Incorporated
// and its suppliers and may be covered by U.S. and Foreign Patents,
// patents in process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Moonshot Health Incorporated.

// @generated by protoc-gen-es v1.3.3 with parameter "target=js,import_extension=none"
// @generated from file msh/resource/v1/user.proto (package msh.resource.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3, Timestamp } from "@bufbuild/protobuf";
import { Agent, ContactTime } from "../../common/v1/common_pb";
import { Language } from "../../common/v1/language_pb";

/**
 * @generated from message msh.resource.v1.User
 */
export const User = proto3.makeMessageType(
  "msh.resource.v1.User",
  () => [
    { no: 1, name: "user_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "display_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "email", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "photo_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "creation_time", kind: "message", T: Timestamp },
    { no: 6, name: "created_by", kind: "message", T: Agent },
    { no: 7, name: "phone", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "lang", kind: "enum", T: proto3.getEnumType(Language) },
    { no: 9, name: "timezone", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "contact_time", kind: "message", T: ContactTime, repeated: true },
    { no: 11, name: "avatar", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
  ],
);

/**
 * @generated from message msh.resource.v1.UserDeviceToken
 */
export const UserDeviceToken = proto3.makeMessageType(
  "msh.resource.v1.UserDeviceToken",
  () => [
    { no: 1, name: "user_device_token_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "user_device_token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

